import { forwardRef, type SelectHTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

/**
 * Thin wrapper around the native <select> so filter bars can stay accessible
 * and keyboard-friendly without pulling in a Radix headless select. Styling
 * matches the Input component.
 */
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm ' +
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ' +
          'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
);
Select.displayName = 'Select';
